import layoutHeaderAside from '@/layout/header-aside'

const meta = { auth: true }

export default {
  path: '/system',
  title: '系统管理',
  component: layoutHeaderAside,
  children: (pre => [
    {
      path: 'index',
      name: `${pre}index`,
      meta: { ...meta, cache: true, title: '系统首页' },
      component: () => import('@/views/system/index')
    },
    {
      path: 'user',
      name: `${pre}user`,
      meta: { ...meta, cache: true, title: '用户管理' },
      component: () => import('@/views/system/user')
    },
    {
      path: 'role',
      name: `${pre}role`,
      meta: { ...meta, cache: true, title: '角色管理' },
      component: () => import('@/views/system/role')
    },
    {
      path: 'menu',
      name: `${pre}menu`,
      meta: { ...meta, cache: true, title: '菜单管理' },
      component: () => import('@/views/system/menu')
    },
    {
      path: 'tableInfo',
      name: `approve-tableInfo`,
      meta: { ...meta, cache: true, title: '单据管理' },
      component: () => import('@/views/system/tableInfo')
    },
    {
      path: 'dict',
      name: `${pre}-dict`,
      meta: { ...meta, cache: true, title: '字典管理' },
      component: () => import('@/views/system/dict')
    }
  ])('sys-')
}
